import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-linear-loader',
  styleUrl: 'signet-linear-loader.scss',
})
export class SignetLinearLoader {
  @Prop() isDeterminate = true;

  render() {
    return (
      <div
        class={
          this.isDeterminate
            ? 'signet-linear-determinate-loader'
            : 'signet-linear-indeterminate-loader'
        }
      ></div>
    );
  }
}
